module.exports = {"id":"ccafs_slc_40","full_name":"Cape Canaveral Air Force Station Space Launch Complex 40","status":"active","location":{"name":"Cape Canaveral","region":"Florida","latitude":28.5618571,"longitude":-80.577366},"vehicles_launched":["Falcon 9"],"details":"SpaceX primary Falcon 9 launch pad, where all east coast Falcon 9s launched prior to the AMOS-6 anomaly. Initially used to launch Titan rockets for Lockheed Martin. Back online since CRS-13 on 2017-12-15."}


//////////////////
// WEBPACK FOOTER
// ./src/assets/launch_site.json
// module id = 35
// module chunks = 0